import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { TArticleCardProps } from '../../ArticleCard/ArticleCard';
import { TPromptsData } from '../../PromptsListSection/types';

export const useCollapsedSection = (
  articles: TPromptsData[] | TArticleCardProps[] | undefined,
  hasMoreArticlesToLoad: boolean,
  pageSize: number,
) => {
  const [isCollapsedSection, setIsCollapsedSection] = useState(false);
  const pathname = usePathname();

  const renderedArticles = isCollapsedSection ? articles?.slice(0, pageSize) : articles;

  const updateCollapsedSection = () => {
    setIsCollapsedSection(!hasMoreArticlesToLoad && renderedArticles?.length === articles?.length);
  };

  useEffect(() => {
    setIsCollapsedSection(true);
  }, [pathname]);

  return {
    isCollapsedSection,
    renderedArticles,
    updateCollapsedSection,
  };
};
